{
  "apiVersion": "0",
  "context": "",
  "id": "",
  "method": "signals/awaiting_for_invoice->GET",
  "data": {
    "items": [
      {
        "deal": "1881207",
        "orderNumber": "1016117299",
        "customer": {
          "id": "101624",
          "name": "ООО ФСК \"Мостоотряд-47\""
        },
        "revenue": 9774000.00,
        "profit": 857502.00,
        "process": "Транзит",
        "status": "У логиста",
        "deliveryType": "Транспорт поставщика"
      },
      {
        "deal": "1894588",
        "orderNumber": "1016140449",
        "customer": {
          "id": "180106",
          "name": "АО «Грани Города»"
        },
        "revenue": 152627.50,
        "profit": 26279.59,
        "process": "Транзит",
        "status": "У логиста",
        "deliveryType": "ЦТС"
      },
      {
        "deal": "1893661",
        "orderNumber": "1016179438",
        "customer": {
          "id": "53533",
          "name": "ООО \"АНТТЕК\""
        },
        "revenue": 48500.00,
        "profit": 8794.99,
        "process": "Транзит",
        "status": "У логиста",
        "deliveryType": "Транспорт поставщика"
      },
      {
        "deal": "1901733",
        "orderNumber": "1016200855",
        "customer": {
          "id": "101624",
          "name": "ООО ФСК \"Мостоотряд-47\""
        },
        "revenue": 20.00,
        "profit": 0.67,
        "process": "Транзит",
        "status": "У логиста",
        "deliveryType": "Транспорт поставщика"
      },
      {
        "deal": "1903918",
        "orderNumber": "1016177833",
        "customer": {
          "id": "101624",
          "name": "ООО ФСК \"Мостоотряд-47\""
        },
        "revenue": 2593484.20,
        "profit": 231914.03,
        "process": "Транзит",
        "status": "У поставщика",
        "deliveryType": "Транспорт поставщика"
      },
      {
        "deal": "1899245",
        "orderNumber": "1016182344",
        "customer": {
          "id": "53533",
          "name": "ООО \"АНТТЕК\""
        },
        "revenue": 547710.00,
        "profit": 48750.10,
        "process": "Транзит",
        "status": "У логиста",
        "deliveryType": "ЦТС"
      },
      {
        "deal": "1905759",
        "orderNumber": "1016190490",
        "customer": {
          "id": "53533",
          "name": "ООО \"АНТТЕК\""
        },
        "revenue": 121943.00,
        "profit": 9994.17,
        "process": "Транзит",
        "status": "В ЦТС",
        "deliveryType": "ЦТС"
      },
      {
        "deal": "1908997",
        "orderNumber": "1016190099",
        "customer": {
          "id": "53533",
          "name": "ООО \"АНТТЕК\""
        },
        "revenue": 217770.00,
        "profit": 33433.22,
        "process": "Транзит",
        "status": "У логиста",
        "deliveryType": "Транспорт поставщика"
      },
      {
        "deal": "1910835",
        "orderNumber": "1016197762",
        "customer": {
          "id": "101624",
          "name": "ООО ФСК \"Мостоотряд-47\""
        },
        "revenue": 34180.00,
        "profit": 4538.33,
        "process": "Транзит",
        "status": "У логиста",
        "deliveryType": "ЦТС"
      },
      {
        "deal": "1911227",
        "orderNumber": "1016197311",
        "customer": {
          "id": "74597",
          "name": "ООО \"ЛМ-СТРОЙ\""
        },
        "revenue": 94602.31,
        "profit": 9859.01,
        "process": "Транзит",
        "status": "В ЦТС",
        "deliveryType": "ЦТС"
      },
      {
        "deal": "1906009",
        "orderNumber": "1016198622",
        "customer": {
          "id": "116658",
          "name": "ООО \"ССТ-М\""
        },
        "revenue": 25445.00,
        "profit": 5120.80,
        "process": "Транзит",
        "status": "У логиста",
        "deliveryType": "ЦТС"
      },
      {
        "deal": "1910641",
        "orderNumber": "1016207164",
        "customer": {
          "id": "139912",
          "name": "ООО \"ГорИнжПроект-Москва\""
        },
        "revenue": 214704.00,
        "profit": 10920.00,
        "process": "Транзит",
        "status": "У логиста",
        "deliveryType": "Транспорт поставщика"
      },
      {
        "deal": "1912458",
        "orderNumber": "1016198631",
        "customer": {
          "id": "101624",
          "name": "ООО ФСК \"Мостоотряд-47\""
        },
        "revenue": 45200.00,
        "profit": 6829.96,
        "process": "Транзит",
        "status": "У логиста",
        "deliveryType": "ЦТС"
      },
      {
        "deal": "1909244",
        "orderNumber": "1016204000",
        "customer": {
          "id": "176629",
          "name": "ООО «РЕРУМС МАРКЕТПЛЕЙС»"
        },
        "revenue": 58454.00,
        "profit": 3211.07,
        "process": "Транзит",
        "status": "У логиста",
        "deliveryType": "ЦТС"
      },
      {
        "deal": "1888778",
        "orderNumber": "1016197902",
        "customer": {
          "id": "148903",
          "name": "ООО \"ДжиЭмЭс\""
        },
        "revenue": 599760.00,
        "profit": 30936.00,
        "process": "Транзит",
        "status": "У логиста",
        "deliveryType": "Транспорт поставщика"
      },
      {
        "deal": "1913113",
        "orderNumber": "1016208710",
        "customer": {
          "id": "74597",
          "name": "ООО \"ЛМ-СТРОЙ\""
        },
        "revenue": 42540.00,
        "profit": 2724.47,
        "process": "Транзит",
        "status": "У логиста",
        "deliveryType": "ЦТС"
      },
      {
        "deal": "1913319",
        "orderNumber": "1016201804",
        "customer": {
          "id": "163016",
          "name": "ООО «ИНВОРКСТРОЙ\""
        },
        "revenue": 234624.00,
        "profit": 14300.00,
        "process": "Транзит",
        "status": "У логиста",
        "deliveryType": "Транспорт поставщика"
      },
      {
        "deal": "1914539",
        "orderNumber": "1016203461",
        "customer": {
          "id": "180106",
          "name": "АО «Грани Города»"
        },
        "revenue": 250125.73,
        "profit": 35460.43,
        "process": "Транзит",
        "status": "У поставщика",
        "deliveryType": "Транспорт поставщика"
      },
      {
        "deal": "1914665",
        "orderNumber": "1016203543",
        "customer": {
          "id": "185544",
          "name": "ИП \"Михайлец\""
        },
        "revenue": 16306.00,
        "profit": 785.00,
        "process": "Транзит",
        "status": "В ЦТС",
        "deliveryType": "ЦТС"
      },
      {
        "deal": "1914239",
        "orderNumber": "1016207595",
        "customer": {
          "id": "117566",
          "name": "ООО «Интерстрой»"
        },
        "revenue": 50000.00,
        "profit": 1479.17,
        "process": "Транзит",
        "status": "В ЦТС",
        "deliveryType": "ЦТС"
      },
      {
        "deal": "1915584",
        "orderNumber": "1016206746",
        "customer": {
          "id": "139893",
          "name": "ООО \"Легион СМ\""
        },
        "revenue": 138431.68,
        "profit": 12431.33,
        "process": "Транзит",
        "status": "В ЦТС",
        "deliveryType": "ЦТС"
      },
      {
        "deal": "1914671",
        "orderNumber": "1016206368",
        "customer": {
          "id": "53533",
          "name": "ООО \"АНТТЕК\""
        },
        "revenue": 19442.00,
        "profit": 1343.33,
        "process": "Транзит",
        "status": "У логиста",
        "deliveryType": "ЦТС"
      },
      {
        "deal": "1916132",
        "orderNumber": "1016208225",
        "customer": {
          "id": "163016",
          "name": "ООО «ИНВОРКСТРОЙ\""
        },
        "revenue": 29908.00,
        "profit": 3401.33,
        "process": "Транзит",
        "status": "В ЦТС",
        "deliveryType": "ЦТС"
      },
      {
        "deal": "1914532",
        "orderNumber": "1016207979",
        "customer": {
          "id": "101624",
          "name": "ООО ФСК \"Мостоотряд-47\""
        },
        "revenue": 6700.00,
        "profit": 1339.18,
        "process": "Транзит",
        "status": "У логиста",
        "deliveryType": "ЦТС"
      },
      {
        "deal": "1914670",
        "orderNumber": "1016208685",
        "customer": {
          "id": "101624",
          "name": "ООО ФСК \"Мостоотряд-47\""
        },
        "revenue": 48000.00,
        "profit": 9987.50,
        "process": "Транзит",
        "status": "У логиста",
        "deliveryType": "ЦТС"
      },
      {
        "deal": "1914670",
        "orderNumber": "1016200802",
        "customer": {
          "id": "101624",
          "name": "ООО ФСК \"Мостоотряд-47\""
        },
        "revenue": 9700.00,
        "profit": 1513.34,
        "process": "Транзит",
        "status": "У логиста",
        "deliveryType": "ЦТС"
      },
      {
        "deal": "1914805",
        "orderNumber": "1016208708",
        "customer": {
          "id": "88346",
          "name": "ООО «А1»"
        },
        "revenue": 15164.53,
        "profit": 1564.94,
        "process": "Транзит",
        "status": "У логиста",
        "deliveryType": "ЦТС"
      },
      {
        "deal": "1914805",
        "orderNumber": "1016208406",
        "customer": {
          "id": "88346",
          "name": "ООО «А1»"
        },
        "revenue": 4169.16,
        "profit": 423.43,
        "process": "Транзит",
        "status": "У логиста",
        "deliveryType": "ЦТС"
      },
      {
        "deal": "1915551",
        "orderNumber": "2066420746",
        "customer": {
          "id": "116658",
          "name": "ООО \"ССТ-М\""
        },
        "revenue": 1955.40,
        "profit": 316.77,
        "process": "Склад",
        "status": "В ЦТС",
        "deliveryType": "ЦТС"
      },
      {
        "deal": "1916073",
        "orderNumber": "1016206861",
        "customer": {
          "id": "180106",
          "name": "АО «Грани Города»"
        },
        "revenue": 216180.00,
        "profit": 30149.76,
        "process": "Транзит",
        "status": "У логиста",
        "deliveryType": "Транспорт поставщика"
      },
      {
        "deal": "1916279",
        "orderNumber": "2066419225",
        "customer": {
          "id": "116658",
          "name": "ООО \"ССТ-М\""
        },
        "revenue": 11084.00,
        "profit": 1570.00,
        "process": "Склад",
        "status": "В ЦТС",
        "deliveryType": "ЦТС"
      },
      {
        "deal": "1913113",
        "orderNumber": "2066419499",
        "customer": {
          "id": "74597",
          "name": "ООО \"ЛМ-СТРОЙ\""
        },
        "revenue": 989.32,
        "profit": 180.84,
        "process": "Склад",
        "status": "В ЦТС",
        "deliveryType": "ЦТС"
      },
      {
        "deal": "1851567",
        "orderNumber": "1016130382",
        "customer": {
          "id": "139644",
          "name": "ООО \"СПЕЦГРАД\""
        },
        "revenue": 1300000.00,
        "profit": 64581.16,
        "process": "Транзит",
        "status": "У поставщика",
        "deliveryType": "Транспорт поставщика"
      },
      {
        "deal": "1910641",
        "orderNumber": "2066424485",
        "customer": {
          "id": "139912",
          "name": "ООО \"ГорИнжПроект-Москва\""
        },
        "revenue": 29433.41,
        "profit": 445.88,
        "process": "Склад",
        "status": "В ЦТС",
        "deliveryType": "ЦТС"
      },
      {
        "deal": "1909478",
        "orderNumber": "1016201487",
        "customer": {
          "id": "53533",
          "name": "ООО \"АНТТЕК\""
        },
        "revenue": 135360.00,
        "profit": 4200.10,
        "process": "Транзит",
        "status": "У логиста",
        "deliveryType": "Транспорт поставщика"
      },
      {
        "deal": "1888207",
        "orderNumber": "1016199824",
        "customer": {
          "id": "53533",
          "name": "ООО \"АНТТЕК\""
        },
        "revenue": 152280.00,
        "profit": 7020.00,
        "process": "Транзит",
        "status": "У логиста",
        "deliveryType": "Транспорт поставщика"
      },
      {
        "deal": "1888207",
        "orderNumber": "1016201775",
        "customer": {
          "id": "53533",
          "name": "ООО \"АНТТЕК\""
        },
        "revenue": 152280.00,
        "profit": 8369.78,
        "process": "Транзит",
        "status": "У логиста",
        "deliveryType": "Транспорт поставщика"
      },
      {
        "deal": "1896421",
        "orderNumber": "1016165079",
        "customer": {
          "id": "53533",
          "name": "ООО \"АНТТЕК\""
        },
        "revenue": 1008423.00,
        "profit": 170055.52,
        "process": "Транзит",
        "status": "У логиста",
        "deliveryType": "Транспорт поставщика"
      },
      {
        "deal": "1896421",
        "orderNumber": "1016165975",
        "customer": {
          "id": "53533",
          "name": "ООО \"АНТТЕК\""
        },
        "revenue": 739510.20,
        "profit": 113040.71,
        "process": "Транзит",
        "status": "У логиста",
        "deliveryType": "ЦТС"
      }
    ]
  }
}